import { render, staticRenderFns } from "./UsersCardRightPanelUserSettings.vue?vue&type=template&id=67a04164&"
import script from "./UsersCardRightPanelUserSettings.vue?vue&type=script&lang=ts&"
export * from "./UsersCardRightPanelUserSettings.vue?vue&type=script&lang=ts&"
import style0 from "./UsersCardRightPanelUserSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VTextField})
